import { Tag, theme } from 'antd';

import { AccessDetail } from '@app/domain-access-interfaces';

type AccessDependencyType = 'Has Both' | 'Has Parent' | 'Has Child' | '';
export const getAccessDependencyType = (accessDetail?: AccessDetail | null): AccessDependencyType => {
  if (accessDetail) {
    if (accessDetail.parentDependencies?.length > 0 && accessDetail.childDependencies?.length > 0) {
      return 'Has Both';
    } else if (accessDetail.parentDependencies?.length > 0) {
      return 'Has Parent';
    } else if (accessDetail.childDependencies?.length > 0) {
      return 'Has Child';
    }
  }

  return '';
};

export type AccessDependencyTypeRendererProps = {
  accessDetail?: AccessDetail | null;
};

export const AccessDependencyRenderer = ({ accessDetail }: AccessDependencyTypeRendererProps) => {
  const { token } = theme.useToken();
  const label = getAccessDependencyType(accessDetail);

  return (
    <>
      {(label === 'Has Parent' || label === 'Has Both') && <Tag color={token.orange6}>Has Parent</Tag>}
      {(label === 'Has Child' || label === 'Has Both') && <Tag color={token.magenta6}>Has Child</Tag>}
    </>
  );
};
